import { createAction } from "redux-actions";

export const REQUESTED_ACTIVITIES = "REQUESTED_ACTIVITIES";
export const RECEIVED_ACTIVITIES = "RECEIVED_ACTIVITIES";
export const REQUESTED_ACTIVITY_BY_ID = "REQUESTED_ACTIVITY_BY_ID";
export const RECEIVED_ACTIVITY_BY_ID = "RECEIVED_ACTIVITY_BY_ID";

export const requestActivities = createAction(REQUESTED_ACTIVITIES);
export const receiveActivities = createAction(
  RECEIVED_ACTIVITIES,
  (activities) => ({ activities })
);

export const requestActivityById = createAction(
  REQUESTED_ACTIVITY_BY_ID,
  (id) => id
);
export const receiveActivityById = createAction(
  RECEIVED_ACTIVITY_BY_ID,
  (activity) => ({ activity })
);
